import {
    FIRMS_AND_INSTRUMENTS_ADAPTER_SERVICE,
    IFirmsAndInstrumentsAdapterService,
} from '../message-adapters/firms-and-instruments-adapter';
import { IClient } from '../../interfaces';
import { IClientsService } from './clients.interface';
import { inject, injectable } from 'inversify';
import { Observable } from 'rxjs';
import { pluckTyped } from '../../helpers';

@injectable()
export class ClientsService implements IClientsService {

    @inject(FIRMS_AND_INSTRUMENTS_ADAPTER_SERVICE) private readonly firmsInstrumentsAdapter: IFirmsAndInstrumentsAdapterService;

    clientObservable(): Observable<Array<IClient>> {
        return this.firmsInstrumentsAdapter.asObservable()
            .pipe(pluckTyped('clients'));
    }
}
